import { render, staticRenderFns } from "./influencer_bio_slide_history.vue?vue&type=template&id=2bbd501a&scoped=true&"
import script from "./influencer_bio_slide_history.vue?vue&type=script&lang=js&"
export * from "./influencer_bio_slide_history.vue?vue&type=script&lang=js&"
import style0 from "./influencer_bio_slide_history.vue?vue&type=style&index=0&id=2bbd501a&scoped=true&lang=css&"
import style1 from "./influencer_bio_slide_history.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd501a",
  null
  
)

export default component.exports